import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TipoCredito } from 'src/app/modelos/tipoCredito.interface';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';

@Component({
  selector: 'app-tipocredito',
  templateUrl: './tipocredito.component.html',
  styleUrls: ['./tipocredito.component.css']
})
export class TipocreditoComponent implements OnInit {

  NuevoTipoCred : Boolean;
  TipoCreditoList : TipoCredito[];
  TipoCreditoNue : TipoCredito;

  EditId : BigInteger;
  EditCod : string;
  EditNom : string;
  SuperEditar : TipoCredito;

  NuevaSuperCod = new FormControl({value:'', disabled: true},[Validators.required]);
  NuevaSuperNom = new FormControl({value:'', disabled: true},[Validators.required]);

  page : number;

  constructor(
    private api:ApiService,
    private router:Router,
    private appService:AppServiceService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.TipoCreditoNue = new TipoCredito;
    this.SuperEditar = new TipoCredito;
    this.NuevoTipoCred = false;
    this.api.getTodosTiposCred().subscribe(data=>{
      this.TipoCreditoList = data;
    });
  }

  Regresar(){
    this.router.navigate(['parametricas']);
  }

  NuevaSuperintendencia(){
    this.NuevoTipoCred = true;
    this.NuevaSuperCod.enable();
    this.NuevaSuperNom.enable();
  }

  Guardar(){
    if(this.NuevaSuperCod.value==''){
      this.toastr.warning('Debe ingresar el codigo.', 'Advertencia!');
      this.ngOnInit();
    } else if(this.NuevaSuperNom.value==''){
      this.toastr.warning('Debe ingresar el nombre.', 'Advertencia!');
      this.ngOnInit();
    } else {
      this.TipoCreditoNue.cod = this.NuevaSuperCod.value;
      this.TipoCreditoNue.nombre = this.NuevaSuperNom.value;
      /*this.api.nuevaSuperintendencia(this.TipoCreditoNue).subscribe(result1=>{
        if(result1){
          this.toastr.success('Superintendencia creada.', 'OK!');
          this.ngOnInit();
        }
      }, error =>{
        this.toastr.error('Error al guardar.', 'Error!');
      });*/
    }
  }

  editarSuper(Super){
    this.SuperEditar.id = Super.id;
    this.SuperEditar.cod = Super.codigo;
    this.SuperEditar.nombre = Super.nombre;
  }

  guardarSuperEditada(){
    /*this.api.nuevaSuperintendencia(this.SuperEditar).subscribe(result2=>{
      if(result2){
        this.toastr.success('Superintendencia editada.', 'OK!');
        this.ngOnInit();
      }
    }, error =>{
      this.toastr.error('Error al editar.', 'Error!');
    });*/
  }

}
